import React from "react";

import Modal from "Util/Modal";

import PropTypes from "prop-types";
import contractFragments from "../../Queries/graphql/contractFragments";
import NewOrderLink from "./link";

class NEDModal extends React.Component {
  state = { isOpen: false, partner: null };

  static defaultProps = {
    background: true
  };

  render() {
    const { contract, currentUser, cssClass, linkText } = this.props;
    return (
      <React.Fragment>
        <a href="#" onClick={e => this.open(e)} className={cssClass}>
          {linkText || contract.contractCode}
        </a>
        {this.state.isOpen && (
          <Modal
            show={this.state.isOpen}
            onClose={() => this.closeModal(true)}
            header="NED Shipments"
            className="draft-order-ned-modal"
            background={this.props.background}
            renderFooter={() => (
              <a
                onClick={() => this.closeModal(false)}
                className="button button--back"
              >
                Back
              </a>
            )}
          >
            <p className="margin-bottom-base">
              Do you want to enable NED Shipments for this order?
            </p>
            <div className="button-group">
              <NewOrderLink
                contract={contract}
                linkText="YES"
                cssClass="button button--white"
                queryParams="shipments_enabled=true"
                closeModal={() => this.closeModal(true)}
              />
              <NewOrderLink
                contract={contract}
                linkText="NO"
                cssClass="button button--white"
                closeModal={() => this.closeModal(true)}
              />
            </div>
          </Modal>
        )}
      </React.Fragment>
    );
  }

  open = e => {
    e.preventDefault();
    this.setState({ isOpen: true });
  };

  closeModal = closeParent => {
    this.setState({ isOpen: false });
    if (closeParent) {
      this.props.closeParentModal();
    }
  };
}

NEDModal.propTypes = {
  contract: contractFragments.object.isRequired,
  closeParentModal: PropTypes.func.isRequired,
  cssClass: PropTypes.string,
  linkText: PropTypes.string,
  background: PropTypes.bool,
  currentUser: PropTypes.object.isRequired
};

export default NEDModal;
